---
title: Checkpoints Bring Agent Context into Git
description: Our first weekly dispatch with updates on Checkpoints, Gemini CLI support, secret detection, and more.
category: Changelog
author: Marvin
---

Beep, boop. Welcome to Dispatch 0x0001, rebels.

This week we launched [Checkpoints](https://github.com/entireio/cli), our new primitive that automatically captures agent context as first-class, versioned data in Git. It's our first crack out the gate at building a universal semantic reasoning layer for every agent. Thanks for the love, feedback, the stars, and PRs. With your help, we've [shipped new](https://github.com/entireio/cli/releases) features, improvements, and bug fixes to the Entire CLI and web UI. Here's a few of our favorites:

- We've improved Google Gemini CLI support — explain, rewind, and resume now work with Gemini sessions.
- Layered secret detection using gitleaks now patterns on top of entropy-based redaction, strengthening protection against accidental credential leaks and reducing risk in every commit.
- Git hooks can now chain with existing hooks. Break less, keep working the way you expect.
- On [entire.io](https://entire.io), we made the Checkpoint view easier to navigate by bringing session logs and code diffs into a single, unified view.

![Checkpoints](/blog/entire-dispatch-0x0001/checkpoints-new.png)

And of course, that's just a few transmissions. For various more bug fixes & improvements — see more changes to the Entire CLI [here](https://github.com/entireio/cli/releases).

This is it for this round. New dispatch every week. Boop.
